import type { Job, Lead } from '@kanda-libs/ks-frontend-services';

import type { CheckoutFinanceRate } from 'pages/Quote/components/Rates/constants';
import { getDepositLimit } from 'pages/Quote/helpers';

export const getMaxCreditLine = (
  rates: CheckoutFinanceRate[],
  job?: Job,
  lead?: Lead,
): number => {
  const maxForRates = Math.max(
    ...rates.map((rate: CheckoutFinanceRate) => rate.maxLoan),
  );

  const minDeposit = Math.min(
    ...(rates
      .map((rate) => getDepositLimit(rate.name, job, lead))
      .map((limit) => parseInt(limit.min, 10)) || []),
  );

  const jobTotal = job?.total?.amount_vat_inclusive?.amount || 0;

  const max = jobTotal - minDeposit;

  return Math.min(max, maxForRates);
};

export const getMaxDurationLabel = (rates: CheckoutFinanceRate[]): string => {
  const maxDurationMonths = Math.max(
    ...rates.map((rate) => parseInt(rate.duration, 10) || 0),
  );

  const durationNumber = Number(maxDurationMonths);

  if (durationNumber < 12) return `${durationNumber} months`;
  if (durationNumber === 12) return '1 year';

  return `${Math.round((durationNumber * 10) / 12) / 10} years`;
};

export const getIsPreApproved = (rates: CheckoutFinanceRate[]): boolean => {
  const etikaRates = rates.filter(
    (rate) => rate.provider === 'etika' && rate.creditLine,
  );

  return etikaRates.length > 0;
};
